module.exports = __webpack_public_path__ + "static/PartnerStampRed-6f14a1fdbf11c15dabaa8ae5d2de13e8.webp";